jQuery.noConflict();
(function($){

    $('.goto').click(function(e){
        e.preventDefault();
        gsap.to(window, {duration: 0.5, scrollTo:$(this).attr('href')});
    });

    $("#go-back").click(function(event) {
        event.preventDefault();
        history.back(1);
      });

})(jQuery);